import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'

var tableId = 'tableUnusedValues';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlPost: string;
}

export class IndexPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _checkAll: JQuery;

    constructor(options: IndexPageOptions) {
        super(options);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.removeSelected = this.removeSelected.bind(this);
        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;

        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Id}' name='selectedRow' value='${rowData.Id}' type='checkbox' onClick="setSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: false,
                    data: 'Id',
                },
                {
                    sortable: false,
                    data: "Key"
                },
                {
                    sortable: false,
                    data: "Level"
                },
                {
                    sortable: false,
                    data: "EntityId",
                    defaultContent: ''
                }
            ]
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
        this._checkAll = Utils.getJQueryById("selectAll");
        this._checkAll.on("change", this.checkBoxAll);
        let btnRemove = Utils.getJQueryById("lnkRemoveSelected");
        btnRemove.on("click", this.removeSelected);
    }

    private removeSelected(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var ids = $("input[name='selectedRow']:checked").map(function () {
            return $(this).val();
        });
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'json',
            data: { ids: ids.get() },
            success: function (data) {
                window.location.href = data;
            }
        });
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedRow']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedRow']");
        let buildSelectAll = Utils.getJQueryById("selectAll")[0];
        if (Utils.isNullOrUndefined(buildSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>buildSelectAll).checked = allCheckboxesChecked;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ConfigurationCleanup/IndexPage.ts
 **/